export default __webpack_public_path__ + "static/digitalFinancialLogoPink-49b98f574536b98153f7bc90ae9ecb9f.png";